export enum UiPageTypeEnum {
    regular,
    object
}